<div class="version-container">
  <div class="title">{{mat_name}}
     <p class="tiny">Imágenes capturadas: {{capturedCount}}/{{cantidadCount}}</p>
  </div>
 
  <div class="header row">
    <div class="col-6 col-sm-6">
       <span class="section-title">Versiones</span>
    </div>
   
    <div class="col-6 col-sm-6">
       <div class="icons">
          <button class="filter-button icon-btn" (click)="menu.toggle($event)"><i class="pi pi-filter"></i></button>
       </div>
       <p-menu #menu [popup]="true" [model]="menuItems"></p-menu>
    </div>

  </div>

  <div class="mt-3 mb-3 d-flex align-items-center justify-content-center">
    <span class="p-input-icon-left">
      <i class="pi pi-search"></i>
      <input
        type="text"
        pInputText
        placeholder="Buscar..."
        [(ngModel)]="search"
      />
    </span>
  </div>

<ng-container *ngFor="let items of sortedMaterialInfo" >
  <div  class="row g-3">
      <p-divider align="center">
         <span class="font-bold text-gray-600">{{items.nombre}}</span>
      </p-divider>
  <div *ngIf="items.versiones.length == 0" class="col-6 col-md-6">
    <div  class="version-card"
        [class.selected]="false"
        >
      <div class="version-name">{{items.nombre}} 1</div>
      <img [src]="'assets/images/example-mat.png'"  alt="version" />
      <div class="actions">
        <span class="status" [class.captured]="false">
          <ng-container *ngIf="false">
            {{ items.capturas > 0 ? 'Capturada' : 'Pendiente' }}
          </ng-container>
        </span>
        <div class="icons">
          <button *ngIf="!hasSesion" class="icon-btn" (click)="onCapture(items, null)"><i class="pi pi-camera"></i></button>
        </div>
      </div>
    </div>
  </div>
  <div *ngFor="let version of getFilteredAndSortedVersions(items.versiones)" class="col-6 col-md-6">
    <div  class="version-card"
        [class.selected]="version === selected"
        >
      <div class="version-name">{{version.material}} {{ version.version }}</div>
      <img (click)="onOpenImage(version,items)" [src]="version.url || 'assets/images/example-mat.png'"  alt="version" />
      <div class="actions">
        <span class="status" 
              [class.captured]="version.capturas > 0"
              [class.omitted]="version.capturas === 0 && version.omitidos > 0">
            <ng-container *ngIf="version.capturas > 0">Capturada</ng-container>
            <ng-container *ngIf="version.capturas === 0 && version.omitidos > 0">Omitida</ng-container>
        </span>
        <div class="icons">
          <button *ngIf="version.capturas == 0 && version.omitidos == 0" (click)="omitItem(items, version)" class="icon-btn" aria-label="Omit">
            <i class="pi pi-ban"></i>
          </button>
          <button *ngIf="!hasSesion" class="icon-btn" (click)="onCapture(items, version)">
            <i class="pi pi-camera"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
</ng-container>



</div>